import * as React from 'react';
import MapButton from './MapButton';
import BaseMapSelect from './BaseMapSelect';
const BaseLayerButton = (props) => {
    const { className, allLayers, baseLayer, setBaseLayer } = props;
    return (React.createElement(MapButton, { className: className },
        React.createElement(BaseMapSelect, { selectedLayer: baseLayer, mapLayers: allLayers, onLayerChange: newLayer => setBaseLayer(newLayer) })));
};
export default BaseLayerButton;
